import React, { useState } from 'react';
import { RequestPopupProps } from './request-modal';
import css from './request-email-modal.module.scss';
import Modal from '../common/modal/modal';
import { useGetTemplateCategories, useGetTemplates } from './data/queries';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import SingleSelectInput from '../form/select-input/select-input';
import { TemplateCategory, TemplateModel } from 'src/types';
import TemplateView from './template-view';

export default function RequestEmailModal({ trigger, onOpen, onClose, title }: Readonly<RequestPopupProps>) {
  const [showTemplate, setShowTemplate] = useState<TemplateModel | null>(null);
  const { data: categories = [] } = useGetTemplateCategories();

  const methods = useForm({
    mode: 'onBlur',
    resolver: yupResolver(
      yup.object({
        categoryId: yup.string(),
        templateId: yup.string()
      })
    ),
    defaultValues: {
      categoryId: categories[0]?.id ?? '',
      templateId: ''
    }
  });
  const {
    control,
    reset,
    watch,
    formState: { isDirty }
  } = methods;

  const category = watch('categoryId');
  const template = watch('templateId');

  const { data: templates = [] } = useGetTemplates(category ?? undefined);

  const onClosePopup = () => {
    reset();
    setShowTemplate(null);
    onClose?.();
  };

  return (
    <Modal trigger={trigger} nested onClose={onClosePopup} onOpen={onOpen} closeOnDocumentClick={!isDirty}>
      {(close: () => void) => (
        <div className={css.request}>
          <button className={css.close} onClick={close} tabIndex={0}>
            &times;
          </button>
          <h1>{title ?? 'Створення запиту до ЦВС (служби супроводу)'}</h1>
          {!showTemplate ? (
            <FormProvider {...methods}>
              <form className={css.form} autoComplete='off'>
                <fieldset>
                  <SingleSelectInput
                    name='categoryId'
                    label='Тип запиту'
                    control={control}
                    options={categories.map((c: TemplateCategory) => ({ value: c.id, label: c.name }))}
                  />
                  {category && (
                    <SingleSelectInput
                      name='templateId'
                      label='Мета запиту'
                      control={control}
                      options={templates.map((c: TemplateModel) => ({ value: c.id, label: c.name }))}
                    />
                  )}
                </fieldset>
              </form>
              <button
                className={css.button}
                disabled={!template || !category}
                tabIndex={0}
                onClick={() => setShowTemplate(templates.find((t: TemplateModel) => t.id === template) ?? null)}>
                Далі
              </button>
            </FormProvider>
          ) : (
            <>
              <p>Використайте наведену нижче інфомацію для формування та відправки листа з необхідними даними</p>
              <TemplateView item={showTemplate} />
            </>
          )}
        </div>
      )}
    </Modal>
  );
}
